import { useTranslation } from 'react-i18next';
import { CHANGE_PASSWORD_TRANSLATION_NAMESPACE } from 'consts';
import { isItEmpty } from 'utils';
import {
  object,
  ref,
  string,
} from 'yup';

export const changePasswordSchema = (isPassword) => {
  const { t } = useTranslation(CHANGE_PASSWORD_TRANSLATION_NAMESPACE);
  const genericError = t('genericErrors.failNextStep');

  const schema = object({
    newPassword: string()
      .required(genericError)
      .test('isValidPsw',
        t('incorrectPasswordFormatting'),
        (value) => (isPassword(value))),
    newPasswordCheck: string()
      .when('newPassword', {
        is: (newPassword) => !isItEmpty(newPassword),
        then: string().required(genericError),
        else: string(),
      })
      .oneOf([ref('newPassword')], t('passwordsMustBeEqual')),
  });

  return schema;
};

export default changePasswordSchema;
